<div class="member-block-dialog" [class.rtl]="isArabic">
    <!-- Icon -->
    <div class="tw-flex tw-flex-col tw-gap-[2rem]">

        <!-- Title -->
        <h2 class="title">
            {{ "account-blocked" | translate }}
        </h2>

        <h2 class="subtitle">
            {{ "account-temporarily-block-msg" | translate }}
        </h2>
    </div>

    <!-- Actions -->
    <div class="tw-flex tw-gap-4 tw-w-full tw-justify-end">

        <button mat-button color="primary" (click)="close()">
            {{ 'OK' | translate }}
        </button>
    </div>
</div>